import { ADDRESS_API } from "../constants/api";
import {
  GetAddressbyTraderIdParamModel,
  GetAddressParamModel,
} from "../model/address";
import {
  getHeadersWithTokenAndTraderId,
  getUrl,
  optionsGet,
} from "./commonService";
import customAxios from "./customAxios";

export default class AddressService {
  getAddressPriceRulesService(params: GetAddressParamModel) {
    let api = ADDRESS_API.PRICERULE;
    api = api.replace("#ADDRESSID#", params.addressId.toString());

    const url = getUrl(api);
    const headers = getHeadersWithTokenAndTraderId(params);
    const options: any = optionsGet(url, headers);

    return customAxios(options).then((res) => {
      return res.data;
    });
  }

  getAddresService(params: GetAddressbyTraderIdParamModel) {
    let api = ADDRESS_API.ADDRESSES;
    api = api.replace("#TRADERID#", params.traderId?.toString() || "0");

    const url = getUrl(api);
    const headers = getHeadersWithTokenAndTraderId(params);
    const options: any = optionsGet(url, headers);

    return customAxios(options).then((res) => {
      return res.data;
    });
  }
}
